// import something here
import { boot } from 'quasar/wrappers';
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
import { handleUnauthorized } from '@/util/router-helpers';

export default boot(async({ store }) => {
   const userData = LocalStorage.getItem('user');
   if (userData) {
      store.commit('auth/setUserAndToken', userData);
      if (userData.token) {
         store.commit('auth/setBearerToken', userData.token);
      }
   }
   store.dispatch('auth/init')
      .catch(() => {
         handleUnauthorized();
      });
});
